// IMPORTANT: THIS FILE IS AUTO GENERATED!
/* eslint-disable */
export const VERSION = {
  "version": "0.4.12",
  "date": "2025-02-10T14:27:56.244Z"
};
/* eslint-enable */
